<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Formulaires d'empreinte en attente d'approbation</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  :label=libelles.marche label-for="input-marches"
                                  label-class="typo-required-field" v-if="isAdmin">
                        <b-form-select
                                id="input-marches"
                                v-model="marcheId"
                                :options="marches"
                                required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                     {{libelles.selectionnerMarche}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="2" offset="6">
                    <b-button v-if="empreintesResult && empreintesResult.totalElements > 0"
                              v-b-modal="'modal-validateAll'" variant="success">Tout approuver
                    </b-button>
                    <b-modal
                            :id="'modal-validateAll'"
                            title="Approbation de formulaires d'empreintes"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            @ok="validerEmpreintes()">
                        <p>Confirmez-vous l'approbation des formulaires d'empreintes aux statuts "{{statutEnum.ATTENTE_MODIFICATION}}" et "{{statutEnum.ATTENTE_SUPPRESSION}}" ?</p>
                    </b-modal>
                </b-col>
            </b-row>
        </b-col>
        <reject-modal @ok="reject"></reject-modal>
        <div v-if="empreintesResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="empreintesResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="empreintesTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(objetPrestation)="row">
                        <div v-b-tooltip.hover
                             :title="row.value">
                            {{truncate(row.value)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="consulterEmpreinte(row.item.id)">
                            <Icon icon="book-open" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(reject)="row">
                      <b-button size="sm" @click="onClickReject(row.item.id)">
                        <Icon icon="times" size="1x"></Icon>
                      </b-button>
                    </template>
                    <template v-slot:cell(validate)="row">
                        <b-button size="sm" v-b-modal="'modal-validate' + row.item.id">
                            <Icon icon="check-square" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-validate' + row.item.id"
                                title="Approbation de formulaire d'empreinte"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="validerEmpreinte(row.item)">
                            <p v-if="row.item.statut === 'ATTENTE_MODIFICATION'">Confirmez-vous la modification de ce
                                formulaire d'empreinte ?</p>
                            <p v-if="row.item.statut === 'ATTENTE_SUPPRESSION'">Confirmez-vous la suppression de ce
                                formulaire d'empreinte ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>

  import EmpreinteEconomiqueStore from "../../stores/EmpreinteEconomiqueStore";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import EmpreinteEconomiqueDto from "../../dtos/EmpreinteEconomiqueDto";
  import {StatutEnum} from "../../constants/enums";
  import moment from 'moment';
  import {truncate} from "../../utils/stringUtil";
  import {libelles} from '../../constants/libelles';
  import hasPermission from "../../filters/hasPermission";
  import {EventBus} from '@/event-bus'
  import SessionStore from '@/stores/SessionStore'
  import RejectModal from "@/components/RejectModal.vue";

  export default {
    components: {RejectModal},
    data() {
      return {
        marcheId: null,
        marches: [],
        selectedEmpreinte: null,
        statutEnum: StatutEnum,
        empreintesResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        libelles: libelles,
        sessionStoreState: SessionStore.state,
      }
    },
    computed: {
      isAdmin() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR"]) && !this.sessionStoreState.marches.length;
      },
      fields() {
        const fields = [
          {label: '', key: 'num', sortable: false},
          {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
          {label: 'Données pour le mois', key: 'date', sortable: true},
          {label: 'Entreprise SIRET', key: 'siretEntreprise', sortable: true},
          {label: 'Entreprise nom', key: 'nomEntreprise', sortable: true},
          {label: 'Objet de la prestation', key: 'objetPrestation', sortable: true},
          {label: 'PME', key: 'pme', sortable: false},
          {label: 'Statut', key: 'statutLabel', sortable: false},
          {label: 'Consulter', key: 'edit', sortable: false},
          {label: 'Approuver', key: 'validate', sortable: false},
          {label: 'Rejeter', key: 'reject', sortable: false}
        ];
        if (!this.marcheId) {
          fields.splice(1, 0, {label: 'Marché', key: 'referenceMarche', sortable: true})
        }
        return fields
      },
      empreintesTable: function () {
        return this.empreintesResult.content.map(empreinte => {
          return {
            id: empreinte.id,
            modifiedDate: new Date(empreinte.modifiedDate).toLocaleDateString(),
            date: moment(empreinte.date).format('MM/YYYY'),
            referenceMarche: empreinte.referenceMarche,
            siretEntreprise: empreinte.siretEntreprise,
            nomEntreprise: empreinte.nomEntreprise,
            objetPrestation: empreinte.objetPrestation,
            pme: empreinte.pme ? 'Oui' : 'Non',
            statut: empreinte.statut,
            statutLabel: StatutEnum[empreinte.statut]
          }
        });
      }
    },
    watch: {
      marcheId() {
        this.search();
      },
    },
    mounted() {
      this.initPagination();
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
        });
        this.search();
      } else {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
        });
      }
    },
    beforeDestroy() {
      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      onClickReject(id) {
        this.$bvModal.show('modal-reject')
        this.selectedEmpreinte = id
      },
      reject(event) {
        EmpreinteEconomiqueStore
          .reject(this.selectedEmpreinte, event.comment)
          .then(() => {
            this.search()
        })
      },
      truncate(value) {
        return truncate(value ,100)
      },
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'modifiedDate', sortDirection: 'desc'}];
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      consulterEmpreinte(id) {
        this.$router.push("/empreinte-economique/" + id);
      },
      validerEmpreinte(empreinte) {
        EmpreinteEconomiqueStore.validate(empreinte).then(() => {
          this.search();
        });
      },
      validerEmpreintes() {
        EmpreinteEconomiqueStore.validateAll().then(() => {
          this.search();
        });
      },
      search() {
        const empreinte = new EmpreinteEconomiqueDto();
        empreinte.marcheId = this.marcheId;
        empreinte.statut = ['ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION'];
        EmpreinteEconomiqueStore.search(empreinte, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.empreintesResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      }
    }
  }
</script>

